import React, { useState } from 'react';
import { useField } from 'formik';
import { Box, useMediaQuery } from '@material-ui/core';
import { useTheme } from 'styled-components';
import WarehouseCardSearch, { WarehouseCardSearchProps, WarehouseSearchStockCard } from '../WarehouseCardSearch/WarehouseCardSearch';
import { SelectField } from '../../../../components/forms/fields';
import { SelectFieldProps } from '../../../../components/forms/fields/SelectField';
import { StockCardsSearchQuery } from '../../../../generated/graphql';

interface WarehouseCardFieldProps {
    searchFieldProps: Pick<WarehouseCardSearchProps, 'name' | 'warehouseIds' | 'currentWarehouseCard' | 'helperText' | 'label'>;
    selectFieldProps: Omit<SelectFieldProps<any>, 'options'>;
    avaialbleWarehouseIds: string[];
}

const WarehouseCardField = ({ searchFieldProps, selectFieldProps, avaialbleWarehouseIds }: WarehouseCardFieldProps) => {
    const [currentWarehouseCard, setCurrentWarehouseCard] = useState(searchFieldProps.currentWarehouseCard);
    const [
        warehouses,
        setWarehouses,
    ] = useState<StockCardsSearchQuery['stockCards'][0]['warehouses']>(searchFieldProps.currentWarehouseCard?.warehouses || []);

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

    const [, inputMeta, inputHelpers] = useField(searchFieldProps.name);
    const [, , selectHelpers] = useField(selectFieldProps.name);

    const { value: inputValue } = inputMeta;
    const { setValue: setInputValue } = inputHelpers;

    const { setValue: setSelectValue } = selectHelpers;

    const filteredWarehouses = warehouses.filter(({ id }) => avaialbleWarehouseIds.includes(id));

    return (
        <Box display="flex" flexDirection={isDesktop ? 'row' : 'column'} justifyContent="space-between">
            <WarehouseCardSearch
                {...searchFieldProps}
                currentWarehouseCard={currentWarehouseCard}
                onlyPieces
                onItemClick={(stockCard: WarehouseSearchStockCard | null) => {
                const stockCardWarehouses = stockCard?.warehouses ?? [];
                setCurrentWarehouseCard(stockCard);
                setInputValue(stockCard?.id || null);
                setWarehouses(stockCardWarehouses);

                if (!stockCard) {
                    setSelectValue(null);
                }

                if (stockCardWarehouses.length > 0) {
                    setSelectValue(stockCardWarehouses[0].id);
                }
            }} value={inputValue}
            />
            <Box mr={2} />
            <SelectField
                {...selectFieldProps}
                disabled={warehouses.length === 0}
                options={filteredWarehouses}
            />
        </Box>
    );
};
export default WarehouseCardField;
